import type { Message, Employee } from '@/types/chat';
import { useEffect, useRef } from 'react';

interface ChatMessageListProps {
  messages: Message[];
  currentUser: Employee;
}

export function ChatMessageList({ messages, currentUser }: ChatMessageListProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  
  // Get the last 10 messages
  const displayedMessages = messages.slice(-10);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-white h-[500px] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
      {displayedMessages.map(message => {
        const isCurrentUser = message.sender_id === currentUser.empUserId;
        return (
          <div key={message.id} className="flex flex-col w-full">
            <div className="flex w-full">
              <div
                style={{
                  backgroundColor: isCurrentUser ? '#374151' : '#e5e7eb',
                  color: isCurrentUser ? '#ffffff' : '#111827',
                  borderRadius: isCurrentUser ? '20px 20px 5px 20px' : '20px 20px 20px 5px',
                  marginLeft: isCurrentUser ? 'auto' : '0',
                }}
                className="max-w-[70%] px-4 py-2"
              >
                <p
                  className="text-sm"
                  style={{ textAlign: isCurrentUser ? 'right' : 'left' }}
                >
                  {message.content}
                </p>
              </div>
            </div>
            <div
              className="text-xs mt-1 px-2"
              style={{
                color: '#6B7280',
                textAlign: isCurrentUser ? 'right' : 'left',
                marginLeft: isCurrentUser ? 'auto' : '0',
                marginRight: isCurrentUser ? '0' : 'auto',
              }}
            >
              {new Date(message.created_at).toLocaleString()}
            </div>
          </div>
        );
      })}
      <div ref={messagesEndRef} />
    </div>
  );
}
